import { ReactComponent as Person1Icon } from "../../../../assets/icons/person1.svg";
import { ReactComponent as EmailIcon } from "../../../../assets/icons/email.svg";

import { Tooltip } from "react-tooltip";
import { plans } from "../../../../constant";
import moment from "moment";

export function UserInfo({ user, onDeactivate, onDelete }) {
  return (
    <div className="p-8 w-full bg-surface-primary rounded-[10px] border-[0.5px] border-border-primary justify-between items-center flex">
      <div className="justify-start items-center gap-3 flex">
        <div className="w-15 h-15 relative bg-surface-secondary rounded-[10px] flex-col justify-start items-start inline-flex">
          <Person1Icon />
        </div>
        <div className="flex-col justify-start items-start gap-2 inline-flex">
          <div className="justify-start items-center gap-2 inline-flex">
            <div className="text-title-three text-content-primary">
              {user?.firstName} {user?.lastName}
            </div>
            <div className="justify-start items-center gap-1.5 flex">
              <div className="justify-start items-start flex">
                <div
                  className={`${
                    plans.find((plan) => plan.type === user?.tier)?.planStyle
                  } text-xs font-medium leading-3 border rounded py-1 px-1.5 flex items-center justify-center w-fit`}
                >
                  {plans.find((plan) => plan.type === user?.tier)?.planName}
                </div>
              </div>

              <img
                data-tooltip-id={`experiences-my-tooltip-${user?.id}`}
                className="w-[21px] h-[21px] rounded"
                src={
                  user?.pms === "CLOUDBEDS"
                    ? "/images/cloudbeds.png"
                    : "/images/mews.png"
                }
                alt="mews"
              />
              <Tooltip
                id={`experiences-my-tooltip-${user?.id}`}
                className="p-2.5 z-[2] !text-content-tertiary !border border-border-secondary !rounded-md !text-[11px] !bg-surface-primary !shadow-dropdown"
                noArrow
              >
                Connected PMS:{" "}
                <span className="text-content-primary font-semibold text-xs">
                  {user?.pms === "CLOUDBEDS" ? "Cloudbeds" : "Mews"}
                </span>
              </Tooltip>
            </div>
          </div>
          <div className="self-stretch justify-start items-center gap-[5px] inline-flex">
            <EmailIcon className="w-5 h-5" />
            <div className="text-callout text-content-secondary">
              {user?.email}
            </div>
          </div>
        </div>
      </div>
      <div className="justify-end items-center gap-3.5 flex">
        <div className="text-caption-one text-content-tertiary">
          Joined on {moment(user?.joinedOn).format("MMM D, YYYY")}
        </div>
        <div className="h-4 w-[1px] bg-border-secondary"></div>
        <div className="justify-start items-center gap-5 flex">
          <button
            type="button"
            onClick={onDeactivate}
            className="text-footnote font-medium text-content-primary hover:text-content-secondary transition-colors duration-300"
          >
            Deactivate
          </button>
          <button
            type="button"
            onClick={onDelete}
            className="text-footnote font-medium text-danger hover:text-danger/70 transition-colors duration-300"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}
